// CORE Polyfills

import 'whatwg-fetch';
import '~utilities/polyfill/prepend';
import '~utilities/polyfill/closest';
import '~utilities/polyfill/custom-elements';
import '~utilities/polyfill/find';
import '~utilities/polyfill/remove';

// Router
import '~routes/router';

// CORE Utilities
import '~utilities/get-service-worker';
import '~utilities/keyboard-focus';
import '~utilities/detect-touch';
import '~utilities/detect-breakpoints';
import AsyncLoad from '~utilities/async-load';
import InitializeScript from '~utilities/initialize-script';
import RemoveBreaks from '~utilities/remove-breaks';
import ScrollToLink from '~utilities/scroll-to-link';
import InAnimation from '~utilities/in-animation';
import Sticky from '~utilities/sticky';
import ExternalLinks from '~utilities/external-links';
import AsyncElement from '~utilities/async-element';

// CORE Development
import Styleguide from '~development/styleguide/js';
import Devbar from '~development/devbar/js';

// CORE Components
import Form from '~components/form/js';
import BypassNavigation from '~components/bypass-navigation/js';
import Modal from '~components/modal/js';
import Tab from '~components/tab/js';
import Accordion from '~components/accordion/js';
import Tabcordion from '~components/tabcordion/js';
import Tooltip from '~components/tooltip/js';
import Image from '~components/image/js';
import Toast from '~components/toast/js';
import Filter from '~components/filter/js';
import AdvancedFilter from '~components/advanced-filter/js';
import Loader from '~components/loader/js';
import Breadcrumb from '~components/breadcrumb/js';
import ContrastButton from '~components/contrast-button/js';
import CustomPlayer from '~components/custom-player/js';
import Carousel from '~components/carousel/js';

// Utilities
import WindowApp from 'utilities/window-app';


// Components
import FormExtend from 'components/form';
import Expand from 'components/expand';
import Replace from 'components/replace';


onLoad();
window.app = new WindowApp();

// Custom Elements
customElements.define('d-devbar', Devbar);
customElements.define('d-styleguide', Styleguide);
customElements.define('c-loader', Loader);
customElements.define('c-tooltip', Tooltip);
customElements.define('c-modal', Modal);
customElements.define('c-bypass', BypassNavigation);
customElements.define('c-tab', Tab);
customElements.define('c-accordion', Accordion);
customElements.define('c-tabcordion', Tabcordion);
customElements.define('c-filter', Filter);
customElements.define('c-advanced-filter', AdvancedFilter);
customElements.define('c-breadcrumb', Breadcrumb);
customElements.define('c-contrast-button', ContrastButton);
customElements.define('c-custom-player', CustomPlayer);
customElements.define('c-carousel', Carousel);
customElements.define('c-expand', Expand);
customElements.define('u-async-element', AsyncElement);

export function onLoad(){
    // SMALL EE Comments Attribute Hack.
    const jsFormComments = document.getElementById('js-form-comments');
    if(jsFormComments) {
        jsFormComments.setAttribute('js-form', 'required');
        jsFormComments.setAttribute('js-language', 'nl');
    }

    new ExternalLinks();
    InitializeScript.async('js-remove-breaks', RemoveBreaks);
    InitializeScript.async('js-form', FormExtend);
    InitializeScript.async('js-image', Image);
    InitializeScript.async('js-in-animation', InAnimation);
    InitializeScript.async('js-async-load', AsyncLoad);
    InitializeScript.async('js-toast', Toast);
    InitializeScript.async('js-scroll-to-link', ScrollToLink);
    InitializeScript.async('js-sticky', Sticky);
    InitializeScript.async('js-replace', Replace);
}
